import { render, staticRenderFns } from "./ReviewMovementAlert.vue?vue&type=template&id=1328e252"
import script from "./ReviewMovementAlert.vue?vue&type=script&lang=js"
export * from "./ReviewMovementAlert.vue?vue&type=script&lang=js"
import style0 from "./ReviewMovementAlert.vue?vue&type=style&index=0&id=1328e252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports